// lib
import React from "react";
import PropTypes from "prop-types";
import { Drawer as MUIDrawer } from "@material-ui/core";
// src
import DatePicker from "containers/plannings/partials/datePicker/DatePicker";
import PresetPicker from "containers/plannings/partials/presetPicker/PresetPicker";

const Drawer = ({ open, onClose }) => (
  <MUIDrawer open={open} onClose={onClose} className="app-drawer">
    <div className="aside-menu">
      <DatePicker />
      <PresetPicker />
    </div>
  </MUIDrawer>
);

Drawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Drawer;
